import React, { useState, useContext } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import PropTypes from 'prop-types';
import { Button } from 'quantux-ui';
import CaseScheduleContext from '../case-schedule/case-schedule-context';
import { gray, salmon } from '../../theme';

const propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  noAvatar: PropTypes.bool,
  avatarImageUrl: PropTypes.string,
  showCloseIcon: PropTypes.bool,
  iconClass: PropTypes.string,
  dataId: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

const CaseUserCard = (props) => {
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  // ==> Context ========================================================
  let readOnlyMode = false;
  const context = useContext(CaseScheduleContext);
  if (context) {
    readOnlyMode = context.readOnlyMode;
  }
  // const { readOnlyMode = false } = useContext(CaseScheduleContext);
  // ==> Props ==========================================================
  const {
    className,
    children,
    avatarImageUrl,
    iconClass,
    showCloseIcon,
    noAvatar,
    dataId
  } = props;

  const styles = StyleSheet.create({
    caseUserCard: {
      display: 'flex',
      alignItems: 'center',
      background: gray[900],
      height: '40px',
      borderRadius: '5px',
      paddingLeft: '4px'
    },
    caseUserCardAvatar: {
      paddingLeft: '8px',
      width: '32px',
      height: '32px',
      fontSize: '32px'
    },
    caseUserCardAvatarIcon: {
      fontSize: '28px'
    },
    details: {
      fontSize: '12px',
      marginLeft: '8px',
      lineHeight: '14px',
      flexGrow: '1'
    },
    closeIcon: {
      fontSize: '24px',
      height: '32px',
      width: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ':hover': {
        color: salmon[500]
      }
    },
    avatarImage: {
      width: 'auto',
      height: '40px',
      maxHeight: '40px',
      borderRadius: '4px'
    }
  });

  const handleOnClose = () => {
    props.onClose(props.dataId);
  };

  return (
    <div
      className={`${className || ''} ${css(styles.caseUserCard)}`}
      style={{ ...props.style }}
      key={dataId}
    >
      {showDeleteWarning &&
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '100%'
          }}
        >
          <Button
            btnType='primary'
            className='mr-2'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '80px',
              minHeight: '32px',
              maxHeight: '32px',
              fontSize: '14px'
            }}
            isOutlineBtn
            onClick={() => setShowDeleteWarning(false)}
          >
            Cancel
          </Button>
          <Button
            btnType='warning'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '80px',
              minHeight: '32px',
              maxHeight: '32px',
              fontSize: '14px'
            }}
            onClick={handleOnClose}
          >
            Delete
          </Button>
        </div>
      }

      {!showDeleteWarning &&
        <>
          {/* User Avatar */}
          {!noAvatar && !props.showAlert
            ? <div className={`fx fx__hv-center ml-1 ${css(styles.caseUserCardAvatar)}`}>
                {!avatarImageUrl
                  ? <i className={`${iconClass || 'fa fa-user-circle-o'} ${css(styles.caseUserCardAvatarIcon)}`} />
                  : <img className={css(styles.avatarImage)} src={avatarImageUrl} />
                }
              </div>
            : null
          }
          {props.showAlert &&
            <div className={`fx fx__hv-center ${css(styles.caseUserCardAvatar)}`}>
              <svg
                width="20"
                height="24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd" d="M16.8 10.461v6.154l2.4 2.462v1.23H0v-1.23l2.4-2.462v-6.153c0-3.791 1.956-6.942 5.4-7.779v-.837C7.8.825 8.604 0 9.6 0s1.8.825 1.8 1.846v.837c3.432.837 5.4 4 5.4 7.778Zm-8.404 6.155h2.4v-2.462h-2.4v2.462Zm2.4-4.923h-2.4V6.77h2.4v4.923Zm1.205 9.845c0 1.354-1.08 2.462-2.4 2.462-1.332 0-2.4-1.108-2.4-2.462h4.8Z"
                  fill="#96C8FF"
                />
              </svg>
            </div>
          }

          {/* User Details */}
          <div className={css(styles.details)}>
            {children}
          </div>
          {/* Close Icon */}
          {showCloseIcon
            ? <div
                className={css(styles.closeIcon)}
                onClick={() => {
                  if (!readOnlyMode) {
                    setShowDeleteWarning(true);
                  }
                }}
              >
                <i
                  className='fa fa-trash'
                  onClick={() => {
                    if (!readOnlyMode) {
                      setShowDeleteWarning(true);
                    }
                  }}
                />
              </div>
            : null
          }
        </>
      }
    </div>
  );
};

CaseUserCard.propTypes = propTypes;
CaseUserCard.defaultProps = {
  showAlert: false,
  style: {}
};

export default CaseUserCard;
